import React from "react";
import { useFormContext } from "react-hook-form";
import TextareaAutosize from "react-textarea-autosize";

const InputTextArea = ({ name, label, minRows = 2, ...rest }) => {
  const { register, errors } = useFormContext();
  const error = errors[name] ? errors[name].message : null;
  return (
    <div className="form-group">
      {label && (
        <label
          htmlFor={name}
          className="form-label form-label-sm font-weight-bold"
          style={{ marginBottom: "0px" }}
        >
          {label}
        </label>
      )}
      <TextareaAutosize
        name={name}
        id={name}
        ref={register}
        className="form-control"
        minRows={minRows}
        {...rest}
      />
      <small className="text-danger">{error}</small>
    </div>
  );
};

export default InputTextArea;
